<style lang="scss" scoped>
.filters {
    position: absolute;
    box-shadow: 0 0 20px -5px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    background-color: #ffffff;
    max-width: 770px;
    z-index: 100;
    top: 70px;

    margin: 0 -4px;

    .tag-col {
        margin: 0 4px;
    }

    .filter-close {
        display: flex;
        position: absolute;
        right: 0;
        top: 0;
        padding: inherit;
        z-index: 100;
        ::v-deep svg {
            cursor: pointer;
            use,
            path {
                fill: #172340;
            }
            &:hover {
                opacity: 0.6;
            }
        }
    }
}
</style>

<template>
    <slide-y-down-transition>
        <div v-if="show" class="filters px-24 pt-24 w-100" v-click-outside="() => $emit('close')">
            <div class="filter-close" @click="$emit('close')" v-html="svg('icon-close')"></div>
            <div class="row mb-lg-24" v-for="(chunk, chunkindex) in chunkedCategories" :key="chunkindex">
                <div class="col-12 mb-24 mb-lg-0 col-lg-4 d-flex flex-wrap justify-content-start align-content-start" v-for="parentCategory in chunk" :key="parentCategory.id">
                    <p class="font-weight-light small w-100 mb-24">{{ parentCategory.parent.name }}</p>
                    <div class="tag-col d-flex" v-for="category in parentCategory.children" :key="category.id">
                        <a class="tag tag-sm mb-8 mr-auto" @click="toggleAndEmitCategory(category)" :class="(selectedCategories.find(sc => sc.id === category.id) !== undefined ? 'tag-accent' : 'tag-gray')" v-html="category.name"></a>
                    </div>
                </div>
            </div>
            <div v-if="cta" class="row mb-24">
                <div class="col-12 text-right">
                    <a class="btn btn-accent" :href="ctaLink">{{ cta }}</a>
                </div>
            </div>
        </div>
    </slide-y-down-transition>
</template>

<script>
import canToggleCategory from "../mixins/can-toggle-category";
import { integer } from 'vee-validate/dist/rules';
import ClickOutside from 'vue-click-outside'

export default {

    mixins: [canToggleCategory],

    directives: { ClickOutside },

    model: {
        prop: 'selectedCategories',
        event: 'input',
    },

    props: {
        chunkSize: {
            type: Number,
            default: 3
        },
        show: {
            type: Boolean,
            default: false,
        },
        selectedCategories: {
            type: Array,
            default: () => []
        },
        groupedCategories: {
            type: Array,
            required: true
        },
        cta: {
            type: String,
        },
        ctaLink: {
            type: String,
        }
    },

    computed: {
        chunkedCategories() {
            if (!this.groupedCategories.length) {
                return [];
            }

            let i, j, t, chunks = [];
            for (i = 0, j = this.groupedCategories.length; i < j; i += this.chunkSize) {
                t = this.groupedCategories.slice(i, i + this.chunkSize)
                chunks.push(t)
            }

            return chunks;
        },
    },

    methods: {
        toggleAndEmitCategory(category) {
            this.$emit('input', this.toggleCategory(category))
        }
    }
}
</script>